var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VueApexCharts',{staticStyle:{"text-align":"left"},attrs:{"type":"pie","options":_vm.pieData.options,"series":_vm.pieData.series}})}
var staticRenderFns = []

export { render, staticRenderFns }